
import zxcvbn from 'zxcvbn';
import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';

const MINIMUM_PASSWORD_LENGTH = 8;
const UNACCEPTABLE_PASSWORD_SCORE = 0;
const BRANDS_TO_COMPARE_PASSWORDS = ['shutterfly', 'lifetouch', 'tinyprints', 'preschools','prestige'];
const SECRET_KEY = 'H#$sdg12T_67964';

export const checkIfBrandNameInPassword = (value) => {
    let validPassword = true;
    BRANDS_TO_COMPARE_PASSWORDS.forEach( (brand) =>{
        if(brand && brand.toLowerCase() === value.toLowerCase()) {
            validPassword = false;
        }
    });
    return validPassword;
}

export const checkIfValidPasword = (email, password) => {
    if(!email || !password) {
        return true;
    }
    email = email.toLowerCase();
    password = password.toLowerCase();
    if(email.indexOf(password) > -1 ) {
        return false;
    }
    return true;
}

export const isPasswordSameAsName = (password = "", firstName = null, lastName = null) => {
    if(password.toLocaleLowerCase() === firstName.toLowerCase()|| password.toLocaleLowerCase() === lastName.toLowerCase()) {
        return true;
    }
    return false;
} 

export const getPasswordStengthStatus = (password = "") => {
    const { score } = zxcvbn(password);
    let status = true;
    if(score <= UNACCEPTABLE_PASSWORD_SCORE) {
        status = false;
    }
    return { score, status };
}

export const getPasswordStatus = (password = "", email, firstName = "", lastName = "") => {
   
    let { status, score } = getPasswordStengthStatus(password);
    if(password.length < MINIMUM_PASSWORD_LENGTH) { // length validation is not matching
          status =  false;
    } else if(isPasswordSameAsName(password, firstName, lastName)) { // check if password is subset of firstname or lastname
          status =  false;
    } else if(!checkIfBrandNameInPassword(password)) { // check if password is subset of brand names
          status =  false; 
    } else if(!checkIfValidPasword(email, password)) { // check if password is subset of email
          status =  false;
    }
    return {
        status,
        score
    }
}

export const excryptedPassword = (password = "") => {
    const encryptedPassword = AES.encrypt(password, SECRET_KEY).toString();
    return encryptedPassword;
}

export const decryptPassword = (encryptedPassword = "") => {
    const bytes = AES.decrypt(encryptedPassword, SECRET_KEY);
    var originalText = bytes.toString(Utf8);
    return originalText;
}


export const skipStrengthValidation = (password) => {
    if(password.length < MINIMUM_PASSWORD_LENGTH) {
        return true;
    }
}